export default function equalList() {
  if (window.innerWidth > 768) {
    const containers = document.querySelectorAll(".spf-lists__equal-columns");

    containers.forEach(function (container) {
      const listItems = container.querySelectorAll("li");

      if (listItems.length > 0) {
        listItems.forEach(function (item) {
          item.style.height = "auto";
        });

        let maxHeight = 0;
        listItems.forEach(function (item) {
          const itemHeight = item.offsetHeight;
          if (itemHeight > maxHeight) {
            maxHeight = itemHeight;
          }
        });

        listItems.forEach(function (item) {
          item.style.height = `${maxHeight}px`;
        });
      }
    });
  } else {
    const listItems = document.querySelectorAll(".spf-lists__equal-columns li");
    listItems.forEach(function (item) {
      item.style.height = "auto";
    });
  }
}
